import FormattedMessage from 'I18n/components/FormattedMessage';
import { Button } from 'foundations-components/transitional/components/Button';
import { Tooltip } from 'foundations-components/transitional/components/Tooltip';
import { jsx as _jsx } from "react/jsx-runtime";
export default function ReportButton({
  dataTestId,
  isCustomer,
  onClick
}) {
  return /*#__PURE__*/_jsx(Tooltip, {
    disabled: isCustomer,
    title: /*#__PURE__*/_jsx(FormattedMessage, {
      message: "marketplace-ui-reviews.actions.loginRequired"
    }),
    children: /*#__PURE__*/_jsx(Button, {
      "data-test-id": dataTestId,
      disabled: !isCustomer,
      marginInlineStart: "200",
      onClick: onClick,
      use: "link",
      children: /*#__PURE__*/_jsx(FormattedMessage, {
        message: "marketplace-ui-reviews.actions.report"
      })
    })
  });
}